'use client';

import { createContext, useContext } from 'react';

const ClientProfileFormContext = createContext(false);

export const ClientProfileFormProvider = ({ children }: { children: React.ReactNode }) => (
  <ClientProfileFormContext.Provider value>{children}</ClientProfileFormContext.Provider>
);

export const useIsClientProfileForm = () => useContext(ClientProfileFormContext);
